import { memo, SVGProps } from "react"

type Outlets = "svg" | "path";

interface EndCallIconProps extends SVGProps<SVGSVGElement> {
  classNames?: Partial<Record<Outlets, string>>;
}

const BaseEndCallIcon = ({ classNames = { svg: "w-4 h-2", path: "fill-white" }, viewBox = "0 0 14 7", ...rest }: EndCallIconProps) => {
  return (
    <svg className={classNames.svg} xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} {...rest}>
      <path className={classNames.path} transform="translate(0.128906 0.00390625)" d="M13.964463 4.0979762L13.826301 4.8638821C13.6968 5.5816588 13.061289 6.0635943 12.341165 5.9901538L10.908265 5.8440123C10.283866 5.7803636 9.8210793 5.2988896 9.6249914 4.615293C9.3587294 3.6870792 9.1874924 2.9987156 9.1874924 2.9987156C8.5331678 2.7155588 7.8870683 2.5367889 7 2.5367889C6.112946 2.5367889 5.4794641 2.7352815 4.8124962 2.9987156C4.8124962 2.9987156 4.6336985 3.6877258 4.3749962 4.615293C4.2021313 5.2350564 3.933953 5.7761145 3.3224423 5.8410559L1.8978298 5.9921865C1.1869892 6.0675669 0.50544351 5.59025 0.30336246 4.8755217L0.086808905 4.1095238C-0.12874715 3.3471284 0.063612677 2.5447702 0.59178847 2.0032139C1.8387324 0.72468442 4.0823965 0.0040162364 6.9933877 0C9.9085789 -0.0039375057 11.887565 0.71282303 13.259739 1.9914911C13.837151 2.5295372 14.101488 3.3385372 13.964463 4.0979762Z" />
    </svg>
  )
}

export const EndCallIcon = memo(BaseEndCallIcon);
